var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"country-image",attrs:{"src":((_vm.$root.cdn_url) + "/assets/images/country-flags/" + (_vm.data.countryCode) + ".png")}})}
var staticRenderFns = []

export { render, staticRenderFns }